import { createSelector } from 'reselect';

const selectnexusARecords = (state: any) => state.nexusARecords;


export const selectnexusARecordsCurrentItem = createSelector([selectnexusARecords], (nexusARecords) => nexusARecords.current);

export const selectnexusARecordsListItems = createSelector([selectnexusARecords], (NexusARecords) => NexusARecords.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectnexusARecordsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectnexusARecordsQueryItems = createSelector([selectnexusARecords], (nexusARecords) => nexusARecords.query);

export const selectnexusARecordsCreatedItem = createSelector([selectnexusARecords], (nexusARecords) => nexusARecords.create);

export const selectnexusARecordsUpdatedItem = createSelector([selectnexusARecords], (nexusARecords) => nexusARecords.update);

export const selectnexusARecordsReadItem = createSelector([selectnexusARecords], (nexusARecords) => nexusARecords.read);

export const selectnexusARecordsDeletedItem = createSelector([selectnexusARecords], (nexusARecords) => nexusARecords.delete);

export const selectnexusARecordsSearchedItems = createSelector([selectnexusARecords], (nexusARecords) => nexusARecords.search);

export const selectnexusARecordsItemsCount = createSelector([selectnexusARecords], (nexusARecords) => nexusARecords.count);

export const selectnexusARecordsItemsFilter = createSelector([selectnexusARecords], (nexusARecords) => nexusARecords.filter);